import { WorldIcon } from '@/Svg/Svg';
import { FormControl, MenuItem, Select } from '@mui/material';
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';

const Languages = () => {
    const languages = [
        { code: "en", label: "English" },
        { code: "fr", label: "French" },
        { code: "es", label: "Spanish" },
        { code: "pt", label: "Portuguese" },
        { code: "de", label: "German" },
        { code: "uk", label: "Ukrainian" },
        { code: "it", label: "Italian" },
        { code: "ru", label: "Russian" },
        { code: "ar", label: "Arabic" },
        { code: "pl", label: "Polish" },
        { code: "nl", label: "Dutch" },
        { code: "yo", label: "Yoruba" },
        { code: "id", label: "Indonesian" },
        { code: "tr", label: "Turkish" },
        { code: "sw", label: "Swahili" },
        { code: "ha", label: "Hausa" },
        { code: "hi", label: "Hindi" },
        { code: "cn", label: "Chinese" },
        { code: "ur", label: "Urdu" }
    ];

    const { i18n, t } = useTranslation();
    const [lang, setLang] = useState(localStorage.getItem("applanguage") || i18n.language || "en");
    const handleChangeLanguage = (value: string) => {
        setLang(value)
        i18n.changeLanguage(value)
        localStorage.setItem("applanguage", value)
    }
    return (
        <div className="flex items-center justify-center gap-1">
            <WorldIcon />
            <FormControl
                variant="standard"
                sx={{
                    "& .MuiInput-underline:before": { borderBottom: "none" },
                    "& .MuiInput-underline:after": { borderBottom: "none" },
                    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                        borderBottom: "none",
                    },
                }}
            >
                <Select
                    value={lang}
                    onChange={(e) => handleChangeLanguage(e.target.value)}
                    displayEmpty
                    sx={{
                        fontSize: "2vw",
                        borderBottom: "0",
                        fontWeight: "600",

                        "& .MuiSelect-select": {
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                        },
                        "@media (min-width: 1024px)": {
                            fontSize: "0.75rem",
                        },
                    }}
                >
                    <MenuItem className={"!font-[600]"} value="" disabled>Select Language</MenuItem>
                    {languages.map((l) => (
                        <MenuItem key={l.code} value={l.code}>{t(l.label)}</MenuItem>
                    ))}</Select>
            </FormControl>
        </div>
    )
}

export default Languages
